module.exports = __webpack_public_path__ + "media/assets/images/plan-polyline-419980e6fc34694e2c026c07e9ac6e30.svg";